import CountrySwitcherIcon from './CountrySwitcherIcon'

export default CountrySwitcherIcon
